"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SPLIT_CLIENT_SIDE_SDK_KEY_DEV = exports.SPLIT_CLIENT_SIDE_SDK_KEY_STAGING = exports.SPLIT_CLIENT_SIDE_SDK_KEY_PROD = void 0;
exports.SPLIT_CLIENT_SIDE_SDK_KEY_PROD = 'tujkvkqnieafmf60bbqk8vfa10q3ndrsh39e';
exports.SPLIT_CLIENT_SIDE_SDK_KEY_STAGING = 'eki85fiedit37hibso5qkqsek5r2830trou5';
exports.SPLIT_CLIENT_SIDE_SDK_KEY_DEV = 'dda4ffb6g3aer6f19187epj7hpgtr9oflqcf';
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uc3RhbnRzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3NwbGl0L2NvbnN0YW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLDhCQUE4QixHQUFHLHNDQUFzQyxDQUFDO0FBRXhFLFFBQUEsaUNBQWlDLEdBQUcsc0NBQXNDLENBQUM7QUFFM0UsUUFBQSw2QkFBNkIsR0FBRyxzQ0FBc0MsQ0FBQyJ9


// WEBPACK FOOTER //
// ../../../src/split/constants.ts